import React, { useRef } from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import HTTPService from '../../utils/makerequest';
import { Toast } from 'primereact/toast';
import { t } from 'i18next';

const { Title } = Typography;

const ForgotPassword = () => {
  const history = useHistory();
  const toast = useRef<any>(null);

  const onFinish = (values) => {
    HTTPService.GET(`/Login/ResetPassword?email=${values.email}`)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: response.data,
            life: 3000
          });
        } else if (response.status === 404) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: response.data,
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t('error_message'),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error("Password reset failed: ", error);
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('password_reset_failed'),
          life: 3000
        });
      });
  };

  const handleCancel = () => {
    history.push('/public/sign-in');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
      <Toast ref={toast} />
      <div style={{ width: '300px', textAlign: 'center' }}>
        <div style={{
          position: 'absolute',
          top: '0',
          left: '300px',
          margin: '230px',
          fontSize: '24px',
        }}>
          <CloseOutlined onClick={handleCancel} />
        </div>
        <Title level={3}>{t('findyour')}</Title>
        <Title level={5}>{t('emailenter')}</Title>
        <Form name="forgot_password" onFinish={onFinish} style={{ marginTop: '200px' }}>
          <Form.Item
            name="email"
            rules={[
              {
                type: 'email',
                message: t('please_input_email'),
              },
              {
                required: true,
                message: t('please_input_email'),
              },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Email" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%', borderRadius: '5px' }}>
              {t('resetpass')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
